// --- React
import React, { useMemo } from 'react';
// --- Utils
import { getNielsenDetails } from '../utils/getDetailsData';
// --- Components
import { FieldRow } from '../../components';
// --- Styles
import '../../styles.scss';

/**
 * NielsenCard (Ratings)
 *
 * Features:
 * - Displays Nielsen/Ratings details in tap-ui style (horizontal label-value)
 * - Supports search/filter functionality
 *
 * @param {object} details - Product details object
 * @param {string} searchTerm - Optional search term to filter fields
 * @returns {Element}
 */
export function NielsenCard({ details, searchTerm = '' }) {
    // Function to extract Nielsen details from the provided data
    const nielsenDetails = useMemo(() => getNielsenDetails(details), [details]);

    // Filter fields based on search term
    const filteredFields = useMemo(() => {
        if (!searchTerm.trim()) return nielsenDetails;

        const term = searchTerm.toLowerCase();
        return nielsenDetails.filter(
            (field) =>
                field.label.toLowerCase().includes(term) ||
                String(field.value || '').toLowerCase().includes(term)
        );
    }, [nielsenDetails, searchTerm]);

    if (filteredFields.length === 0 && searchTerm.trim()) {
        return (
            <div className="no-results">
                <i className="fa-solid fa-search" />
                <p>No fields match your search.</p>
            </div>
        );
    }

    return (
        <div className="nielsen-card">
            <div className="detail-section-content">
                {filteredFields.map(({ label, value }, idx) => (
                    <FieldRow
                        key={`nielsen-${idx}`}
                        label={label}
                        value={value}
                        noBorder={idx === filteredFields.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
